// extracted by mini-css-extract-plugin
export default {"container":"RY-z","list":"SY-z"};